
export default function Services() {
  const services = [
    {
      icon: 'ri-brain-line',
      iconBg: 'bg-gradient-to-br from-red-600 to-red-800',
      title: 'Neuro Agents Global AI',
      description: 'Plataforma revolucionária de agentes de IA personalizados com geração avançada de imagens e automação inteligente para transformar seu negócio.',
      badge: 'Tecnologia Exclusiva',
      badgeColor: 'bg-red-600/20 text-red-400 border border-red-600/30',
      buttonText: 'Explorar Plataforma',
      buttonColor: 'border-red-600 text-red-400 hover:bg-red-600/10',
      link: 'https://neuroagentsglobal.com/'
    },
    {
      icon: 'ri-robot-2-line',
      iconBg: 'bg-gradient-to-br from-cyan-600 to-cyan-800',
      title: 'Agentes de IA Personalizados',
      description: 'Crie agentes de IA personalizados com geração de imagens avançada. Automatize processos e potencialize seu negócio com inteligência artificial.',
      badge: 'IA Avançada',
      badgeColor: 'bg-cyan-600/20 text-cyan-400 border border-cyan-600/30',
      buttonText: 'Criar Agente',
      buttonColor: 'border-cyan-600 text-cyan-400 hover:bg-cyan-600/10',
      link: 'https://lp.aros.com.br?fpr=rafael-figueiredo-silva43'
    },
    {
      icon: 'ri-code-s-slash-line',
      iconBg: 'bg-gradient-to-br from-emerald-600 to-emerald-800',
      title: 'Sites com IA em Minutos',
      description: 'Ferramenta avançada que cria websites profissionais completos usando inteligência artificial. Do design ao deploy em minutos, sem bugs.',
      badge: 'Automação Total',
      badgeColor: 'bg-emerald-600/20 text-emerald-400 border border-emerald-600/30',
      buttonText: 'Criar Meu Site',
      buttonColor: 'border-emerald-600 text-emerald-400 hover:bg-emerald-600/10',
      link: 'https://readdy.ai/?via=rafael'
    }
  ];

  return (
    <section id="servicos" className="py-16 sm:py-20 bg-dark-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center mb-4">
          <div className="w-3 h-3 rounded-full bg-red-500 mr-3"></div>
          <span className="text-sm font-semibold text-gray-500 tracking-wider uppercase">SERVIÇOS PREMIUM</span>
        </div>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">Soluções em IA e Gestão</h2>
        <p className="text-base sm:text-lg text-gray-400 mb-12 sm:mb-16 max-w-2xl">
          Tecnologias de ponta em inteligência artificial e sistemas de gestão para impulsionar seu sucesso
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-product-shop>
          {services.map((service, index) => (
            <div 
              key={index}
              className="relative bg-dark-800 rounded-2xl p-6 border border-dark-600 hover:border-red-600/50 transition-all duration-300 hover:-translate-y-2 group"
            >
              <span className={`absolute top-4 right-4 ${service.badgeColor} text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap`}>
                {service.badge}
              </span>
              
              <div className={`w-14 h-14 sm:w-16 sm:h-16 ${service.iconBg} rounded-xl flex items-center justify-center mb-5 shadow-lg`}>
                <i className={`${service.icon} text-2xl sm:text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-lg sm:text-xl font-bold text-white mb-3 pr-20">{service.title}</h3>
              <p className="text-gray-400 mb-6 leading-relaxed text-sm">{service.description}</p>
              
              <a 
                href={service.link}
                target={service.link.startsWith('http') ? '_blank' : '_self'}
                rel={service.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                className={`w-full border-2 ${service.buttonColor} px-5 py-3 rounded-lg font-semibold transition-all cursor-pointer whitespace-nowrap flex items-center justify-center text-sm sm:text-base`}
              >
                {service.buttonText}
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
